import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';

import { MetabaseDashboardPage } from '@shared/components';
import { getLocalStorage } from '@shared/constants/local-storage';
import { TRACK_EVENTS } from '@payfac/constants';
import { useGetReportSignedDashboard } from '@payfac/services';

export const TransactionsAnalytics = () => {
    const { t } = useTranslation();
    const posthog = usePostHog();
    const idCompany = Number(getLocalStorage('companyId')) || 0;

    const { data, isLoading } = useGetReportSignedDashboard("payfac-transactions", idCompany);

    const dashboardUrl = data?.data?.url;
    const isError = !!data && !data.success;

    useEffect(() => {
        if (!idCompany) return;
        posthog.capture(TRACK_EVENTS.TRANSACTIONS.VIEWED, { company_id: idCompany });
    }, [idCompany]);

    useEffect(() => {
        if (isError) {
            posthog.capture(TRACK_EVENTS.TRANSACTIONS.LOAD_ERROR, { company_id: idCompany });
        }
    }, [isError]);

    return (
        <MetabaseDashboardPage
            title={t('payfac.pageAnalyticsTransactionsTitle')}
            iframeSrc={dashboardUrl}
            isLoading={isLoading}
            isError={isError}
            hasCompany={!!idCompany}
            loadingMessage={t('payfac.pageAnalyticsLoading')}
            errorMessage={t('payfac.pageAnalyticsError')}
            emptyCompanyMessage={t('payfac.pageReportsCompanyNotFound')}
            onLoaded={() => posthog.capture(TRACK_EVENTS.TRANSACTIONS.LOADED, { company_id: idCompany })}
        />
    );
};
